import React from "react";
import ModalBase from "./ModalBase";
import { Stack } from "@mui/material";
import { FieldValues, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import PasswordInput from "../input/PasswordInput";
import { IWrapperInput } from "../input/WrapperInput";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import { API_URL, ID_APP } from "../../../utils/constants";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../contexts/alert/AlertProvider";

interface IModalResetPassword extends Omit<IWrapperInput, "children"> {
  open: boolean;
  title: string;
  email: string;
  onClose: () => void;
}

const schema = yup.object<FieldValues>({
  newPassword: yup.string().required("Vui lòng nhập mật khẩu"),
  reNewPassword: yup
    .string()
    .required("Vui lòng nhập lại mật khẩu")
    .oneOf([yup.ref("newPassword")], "Mật khẩu nhập lại không khớp"),
});

function ModalResetPassword({
  email,
  title,
  open,
  onClose,
}: IModalResetPassword) {
  const { token } = useSelector((state: any) => state.auth);
  const { showAlert } = useAlertContext();
  const defaultData: FieldValues = {
    email,
    newPassword: "",
    reNewPassword: "",
  };
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = useForm<FieldValues>({
    defaultValues: defaultData,
    mode: "onSubmit",
    resolver: yupResolver(schema),
  });

  const handleSave = async (values: any) => {
    try {
      await axios.post(
        `${API_URL}/changepasswordByAdmin?access_token=${token}&id_app=${ID_APP}`,
        values
      );
      showAlert({ type: "success", message: "Cấp nhật thành công" });
      onClose();
    } catch (error: any) {
      const resp = error?.response;
      showAlert({
        type: "error",
        message: resp?.data?.message || resp?.data?.error || "Vui lòng thử lại",
      });
    }
  };

  return (
    <ModalBase open={open} handleClose={onClose} title={title} width="400px">
      <Stack
        component="form"
        gap={1}
        sx={{ px: 2 }}
        onSubmit={handleSubmit(handleSave)}
      >
        <PasswordInput
          direction="column"
          label="Mật khẩu mới"
          placeholder="Nhập mật khẩu mới"
          name="newPassword"
          register={register}
          errorMessage={errors?.newPassword?.message as string}
        />
        <PasswordInput
          direction="column"
          label="Xác nhận mật khẩu"
          placeholder="Nhập lại mật khẩu mới"
          name="reNewPassword"
          register={register}
          errorMessage={errors?.reNewPassword?.message as string}
        />
        <LoadingButton
          loading={isSubmitting}
          type="submit"
          variant="contained"
          sx={{
            boxShadow: "none",
            textTransform: "none",
            color: "common.white",
            "&:hover": { boxShadow: "none" },
          }}
        >
          Xác nhận
        </LoadingButton>
      </Stack>
    </ModalBase>
  );
}

export default ModalResetPassword;
